import { Link } from "react-router-dom";

export default function SpecifiedCommercialTransactionsPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="text-sm font-semibold text-teal-700 hover:text-teal-800">
            ← トップへ戻る
          </Link>
          <span className="text-sm text-gray-500">株式会社つくし映像</span>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">特定商取引法に関する表記</h1>
        <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
          本ページは、特定商取引法に基づき表示する事項を掲載しています。
        </p>

        <div className="mt-10 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <dl className="divide-y divide-gray-100">
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">販売事業者</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">株式会社つくし映像</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">所在地</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">〒311-2103 茨城県鉾田市秋山618番地2</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">電話番号</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">
                <a className="text-teal-700 hover:text-teal-800" href="tel:08022504380">080-2250-4380</a>
              </dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">受付時間</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">9時〜17時</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">販売価格</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">基本料金は料金プランに記載済み。合計額についてはお見積りによる</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">商品代金以外の必要料金</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">通信費等（お客様負担）</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">お支払い方法</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">銀行振込（詳細はご契約時にご案内いたします）</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">お支払い時期</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">ご契約内容に準じます</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">提供時期</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">日程確定後、天候状況を踏まえて実施</dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">キャンセル・変更</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">
                散布完了後のキャンセル・返品はお受けできません。散布着手前のキャンセルについては、発生した費用（機材費・薬剤費・その他材料、諸経費等）をご請求させていただく場合があります。詳細はご契約時にご確認ください
              </dd>
            </div>
            <div className="px-6 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-semibold text-gray-700 sm:col-span-1">返品・返金</dt>
              <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2">
                サービスの性質上、作業実施後の返品には応じられません。返金条件は個別の契約・見積条件に従います。
              </dd>
            </div>
          </dl>
        </div>
      </main>

      <footer className="border-t border-gray-100 py-8">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-sm text-gray-500 flex items-center justify-between">
          <span>&copy; 2026 株式会社つくし映像</span>
          <Link to="/" className="text-teal-700 hover:text-teal-800">トップへ</Link>
        </div>
      </footer>
    </div>
  );
}

